<template>
  <div
    class="orm-mb-16 orm-col-xs-12 orm-col-sm-8 orm-col-md-6 orm-col-lg-4 orm-px-xs-8"
    v-if="filter"
    :rel="JSON.parse(JSON.stringify(car.toString()))"
  >
    <div class="orm-caroffers__element">
      <div class="orm-slider__image__container">
        <Slider v-if="images" :images="images" :autoplay="true" />
        <div v-else :style="{ paddingTop: '75%' }"></div>
      </div>
      <div class="orm-cartitle">
        <h2 class="orm-headline__h2">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARGROUP]) }}
        </h2>
        <p class="orm-headline__h2__subheadline orm-relative">
          {{ stripHTML(data[env.VUE_APP_RESERVATION_CARCATEGORY]) }}
          <i class="fal fa-question-circle orm-cargroup__tooltip"
            ><span
              class="orm-cargroup__tooltip_text orm-cargroup__tooltip-bottom"
              >{{ i18n("cargroup/noguarantee") }}</span
            ></i
          >
        </p>
      </div>
      <div class="orm-cardetails">
        <div class="orm-carequip">
          <p class="orm-equip__txt__icons">
            <equipIcon :data="data.features" :shortlist="true" />
          </p>
        </div>
      </div>
      <div class="orm-carbutton">
        <button
          @click="select(data)"
          class="orm-button__cta outline wide"
          :class="[station ? '' : 'disable']"
        >
          {{ i18n("cargroup/select") }}
        </button>
      </div>
    </div>
  </div>
  <Modal
    v-if="showModal && selectedCargroup"
    :car="selectedCargroup"
    :show-category="showCategory"
    :sttype="sttype"
    @cancel="cancel()"
  />
</template>

<script>
import { defineComponent } from "vue";
import store from "@/store";
import equipIcon from "@/components/reservation/equip-icon.vue";
import Slider from "@/components/ui/image-slider.vue";
import i18n from "@/mixins/mixins";
import stripHTML from "@/mixins/mixins";
import Modal from "@/components/modals/modal-stationtimeselect.vue";

export default defineComponent({
  name: "car-list-search",
  components: {
    equipIcon,
    Modal,
    Slider,
  },
  mixins: [i18n, stripHTML],
  data() {
    return {
      car: Object,
      images: [],
      showSearch: false,
      station: store.getters["userSession/GET_STATION"],
      selectedStation: null,
      env: process.env,
      showModal: false,
    };
  },
  props: {
    data: Object,
    filter: Boolean,
    stations: Object,
    opened: String,
  },
  async mounted() {
    this.car = await this.data;
    this.images = this.car.images;
    store.watch(
      (state, getters) => getters["userSession/GET_STATION"],
      (val) => {
        this.station = store.getters["stations/GET_STATION_BY_ID"](val);
      }
    );
  },
  methods: {
    select(item) {
      this.selectedCargroup = item;
      this.showModal = true;
    },
    cancel() {
      this.selectedCargroup = null;
      this.showModal = false;
    },
  },
});
</script>
